export default __webpack_public_path__ + "static/rusUz-cover-b6c54c77841bb45bf33962bec34c68cc.jpg";